import { useSummary } from './useSuQueries';
import { formatLastRefreshed } from '../utils/lastRefreshed';

/** "Last refreshed: HH:MM (GMT +5:30)" for screens that don't load the summary themselves (null until known). */
export function useLastRefreshed(): string | null {
  const { data } = useSummary();
  return formatLastRefreshed(data?.as_of);
}
